import React from 'react';

import { useMobilePageIframeSrc } from './useMobilePageIframeSrc';
import { useMobilePageIframe } from './useMobilePageIframe';

const MobileDevicePage = () => {
  const iframeSrc = useMobilePageIframeSrc();
  const { iframeHeight } = useMobilePageIframe();

  return (
    <iframe
      title="mobile-lp"
      src={iframeSrc}
      allow="clipboard-read; clipboard-write"
      height={iframeHeight}
      width="100%"
    />
  );
};

export default MobileDevicePage;
